/* eslint-disable no-console */
import {    
  StyledTreeItem,
  StyledCheckbox,
  StyledTreeView,
} from './styles';

import { default as LayerModel } from 'services/models/Layer';

/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useRef permite que persista valores entre renderizações, ele pode
 * ser usado para armazenar um valor mutável que não causa uma nova
 * renderização quando atualizado e pode ser usado para acessar di-
 * retamente um elemento do DOM.
 */
import { useState, useEffect, useRef } from 'react';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';

/**
 * CustomTreeItem
 * 
 * @param {array} item
 * @param {function} onClick
 * @param {*} persistentSelected Mante selecionado
 * @param {function} handleSelectWorkspaceLayer Mexe com a camada selecionada
 * 
 * @returns 
 */
const CustomTreeItem = ({  
  item,  
  onClick,  
  persistentSelected,  
  handleSelectWorkspaceLayer,
}) => {
  if (item) {    
    let layerTitle = item.Title || 'Sem nome';
    return (
      <StyledTreeItem
        label={
          <div
            className="custom_tree_item"
            onClick={(e) => {
              e.stopPropagation();              
              onClick && onClick(e);
            }}
          >
            <p
              onClick={(e) => {
                e.stopPropagation();                
                onClick && onClick(e);
              }}
            >
              {layerTitle}
            </p>
            <StyledCheckbox
              checked={persistentSelected.includes(item)}
              color="primary"
              onClick={(e) => {
                e.stopPropagation();                
                handleSelectWorkspaceLayer(e, [item]);
              }}
              size="small"
            />
          </div>
        }
      >
      </StyledTreeItem>
    );
  }
};

/**
 * default
 * 
 * @param {array} listWorkspaceLayers Lista as camadas da area
 * @param {object} loadedLayers Carrega as camadas
 * @param {function} showDetails Mostra os detalhes
 * @param {boolean} callback
 * @param {string} searchQuery Faz a busca
 * @param {*} highlightFirstLayer
 * 
 */
export default ({
  listWorkspaceLayers,
  layers: loadedLayers,
  showDetails,
  callback,
  searchQuery,
  highlightFirstLayer,
}) => {
  const [persistentSelected, setPersistentSelected] = useState([]);
  const [selected, setSelected] = useState([]);  
  const initialLayers = useRef([]);
  const { layers: contextLayers } = useMap();

  const handleSelectWorkspaceLayer = (event, index) => {
    setSelected(index);
  };
  const removeAccent = (text) => {       
      text = text.toLowerCase();                                                         
      text = text.replace(new RegExp('[ÁÀÂÃ]','gi'), 'a');
      text = text.replace(new RegExp('[ÉÈÊ]','gi'), 'e');
      text = text.replace(new RegExp('[ÍÌÎ]','gi'), 'i');
      text = text.replace(new RegExp('[ÓÒÔÕ]','gi'), 'o');
      text = text.replace(new RegExp('[ÚÙÛ]','gi'), 'u');
      text = text.replace(new RegExp('[Ç]','gi'), 'c');
      return text;                 
  } 
  useEffect(() => {
    let tmpPersistentSelected = [...persistentSelected];
    if (selected.length) {
      selected.forEach((item) => {
        // Se item já esta na lista, remove
        if (tmpPersistentSelected.includes(item)) {
          tmpPersistentSelected.splice(
            tmpPersistentSelected.indexOf(item),
            1
          );
        } else{
          tmpPersistentSelected.push(item);
        }        
      });
      setPersistentSelected(tmpPersistentSelected);
    }
    // Aqui eu não posso habilitar a dependência de persistentSelected senão daria infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  // Limpa lista de itens selecioandos 
  // quando realizada nova requisição  
  useEffect(() => {
    setPersistentSelected([]);
  }, [listWorkspaceLayers]);

  useEffect(() => {
    if (!initialLayers.current.length) {
      initialLayers.current = contextLayers.reduce((acc, cur) => {
        return [...acc, LayerModel.generateId(cur)];
      }, []);      
    }
  }, [contextLayers]);
  
  useEffect(() => {
    if (callback) callback(persistentSelected);
  }, [persistentSelected, callback]);

  return (
    <StyledTreeView
      multiSelect
      highlightFirstLayer={highlightFirstLayer}
    > 
      {listWorkspaceLayers?.filter((item) => {
        if(!searchQuery){          
          return listWorkspaceLayers
        }else if(searchQuery.length === 1 || searchQuery.length === 2){
          return listWorkspaceLayers
        }else if (searchQuery.length >= 3){
          let titles = item.Title
          let titlesNoAccent = removeAccent(titles)
          let textSearch = removeAccent(searchQuery)
          let list = titlesNoAccent.includes(textSearch)     
          return list
        }
        return null
      })
      .map((l, key) => { 
        return (
          <CustomTreeItem
            key={key}            
            item={l}            
            persistentSelected={persistentSelected}
            selected={selected}            
            handleSelectWorkspaceLayer={handleSelectWorkspaceLayer} 
          />
        );
      })}
    </StyledTreeView>
  );
};
